{
  "en": {
    "answers": [],
    "tags": [
      {
        "id": 9936,
        "name": "True/False"
      },
      {
        "id": 156068,
        "name": "Sample Question"
      }
    ],
    "text": "The Earth rotates once on its axis in 24 hours.",
    "is_poll_question": false,
    "type": 1,
    "created_at": "2025-09-02T14:45:13.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:55:15.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "weblink": "https://quizacademy.de/tipps/#Tipps%20f%C3%BCr%20Quizfragen",
    "has_weblink": true,
    "explanation": "**This statement is correct:**\n\nThe Earth rotates once on its axis in 24 hours.\n\n**Further Information:**\n\n* The Earth takes about 24 hours to complete a full rotation on its axis.\n* This is why we experience day and night.\n\n**Notes:**\n\n* True/False questions are ideal for testing understanding of text excerpts, facts, theories, or images.\n* They are quick to create and can also be combined with more complex formats such as multiple-choice questions.\n* A balanced mix of question types increases learning effectiveness.\n* Make sure statements are clear and unambiguous.\n\nLearning content should be coordinated across the course for better sustainability. Use a mix of all question types and adapt existing questions when useful. True/False questions are quick to create, while multiple-choice questions are generally the most complex form of quiz questions.",
    "has_explanation": true,
    "num_answers": 0,
    "is_right": true
  },
  "de": {
    "answers": [],
    "tags": [
      {
        "id": 9427,
        "name": "Musterfrage"
      },
      {
        "id": 9936,
        "name": "True/False"
      }
    ],
    "text": "Die Erde dreht sich in 24 Stunden einmal um ihre eigene Achse.",
    "is_poll_question": false,
    "type": 1,
    "created_at": "2025-09-03T08:00:33.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:17:21.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "weblink": "https://quizacademy.de/tipps/#Tipps%20f%C3%BCr%20Quizfragen",
    "has_weblink": true,
    "explanation": "**Diese Aussage ist  richtig.**\n\nDie Erde dreht sich in 24 Stunden einmal um ihre eigene Achse.\n\n**Weiterführende Informationen:**\n\n* Die Erde benötigt rund 24 Stunden für eine vollständige Rotation um ihre Achse. \n* Daher erleben wir Tag und Nacht.\n\n**Hinweise:**\n\n* True/False-Fragen eignen sich ideal, um Verständnis von Textauszügen, Fakten, Theorien oder Bildern zu überprüfen.\n* Sie sind besonders schnell zu erstellen und können auch in Kombination mit komplexeren Fragetypen wie Multiple-Choice genutzt werden.\n* Eine ausgewogene Mischung verschiedener Fragetypen steigert den Lerneffekt.\n* Achte darauf, dass Aussagen eindeutig und nicht missverständlich formuliert sind.\n\nDie Lerninhalte aus den Kursen sollten aufeinander abgestimmt werden. Somit wird der Kurs insgesamt nachhaltiger. Verwende eine ausgewogene **Mischung aus allen Fragetypen** und nutze bereits vorhandene Fragen oder ändere sie ein wenig ab. True/False-Fragen lassen sich recht schnell erstellen, wobei Multiple-Choice-Fragen insgesamt die schwierigste Form unter den Quizfragen sind.",
    "has_explanation": true,
    "num_answers": 0,
    "is_right": true
  }
}
